import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  form,
  Form as AppForm,
  Select,
  Check
} from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { Col, Row } from "react-bootstrap";
import { QC_STATUS } from "MODULES/inventories/constants";
import api from "APP_ROOT/api";
import validate from "./validate";
import { updateQCStatus } from "../../actions";
import { QC_STATUS_TYPES } from "../../constants";

function Form(props) {
  const [poLineCount, setPoLineCount] = useState(0);
  const parentRecordType = props.receivingRecord.reference_record_type;

  useEffect(
    () => {
      if (parentRecordType === "PurchaseOrder") {
        api.inventories
          .search({
            limit: 1,
            purchase_order_id: props.receivingRecord.reference_record_id
          })
          .then(({ data: { total_count: total } }) => {
            setPoLineCount(total);
          });
      }

      return function cleanup() {};
    },
    [props.receivingRecord.id]
  );

  const showApplyAll = poLineCount > 1 || parentRecordType !== "PurchaseOrder";

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <Field
                name={QC_STATUS}
                component={Select}
                options={toOptions(QC_STATUS_TYPES)}
                label="QC Status"
                required
              />
            </div>
          </Col>
        </Row>
        {showApplyAll && (
          <Row>
            <Col md={12}>
              <div className="form-group">
                <label
                  className="control-label"
                  htmlFor="bulk_update_qc_status"
                >
                  {`Apply to All Inventory for ${props.referenceNumber ||
                    props.consignmentReference}`}
                </label>
                <br />
                <div
                  className="btn-group full-width-checkbox"
                  data-toggle="buttons"
                >
                  <Field
                    name="bulk_update_qc_status"
                    component={Check}
                    label="Yes"
                  />
                </div>
              </div>
            </Col>
          </Row>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  referenceNumber: PropTypes.string.isRequired
};

export default connect(undefined, { onSubmit: updateQCStatus })(
  form({
    form: "updateQCStatus",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/EditQCStatus/Form.jsx